import VueGtag from 'vue-gtag';

export default function (Vue) {
  Vue.use(
    VueGtag,
    {
      config: { id: 'UA-33489215-14' },
    },
    Vue.router
  );
}
